export default "__VITE_ASSET__525c1252__"